'use strict';

import angular from 'angular';

export default angular.module('storageApp.mouse', [])
  .directive('rightClick', function($parse){
    'ngInject';

    return function(scope, element, attrs) {
      var fn = $parse(attrs.rightClick);
      element.bind('contextmenu', function(event) {
        scope.$apply(function() {
          event.preventDefault();
          fn(scope, {$event:event});
        });
      });
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/mouse/mouse.js